<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                {{ site.name }}&nbsp;
                <Badge v-if="site.stateId === 2" type="warning">Archived</Badge>
              </h4>
            </div>
            <edit-button
              :stateId="site.stateId"
              @edit-click="editSite"
            ></edit-button>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Consultant</strong>
                  <br />
                  {{ site.consultantName }}
                </p>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Client</strong>
                  <br />
                  <router-link :to="{ name: 'Client' }">{{
                    site.clientName
                  }}</router-link>
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Buildings</h4>
            </div>
            <add-button
              :visible="site.stateId === 1"
              @add-click="addBuilding"
            ></add-button>
          </md-card-header>
          <md-card-content>
            <buildingList></buildingList>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BuildingList from "../buildings/BuildingList";
import { Badge } from "@/components";

export default {
  components: {
    BuildingList,
    Badge
  },
  computed: {
    ...mapGetters({
      site: "data-management-client/site"
    })
  },
  created() {
    this.$store.dispatch(
      "data-management-client/getSite",
      this.$route.params.siteId
    );
  },
  methods: {
    addBuilding() {
      this.$router.push({ name: "Add Building" });
    },
    editSite() {
      this.$router.push({
        name: "Edit Site",
        params: { siteId: this.site.id }
      });
    }
  }
};
</script>

<style></style>
